'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var debug = require('debug');

var ipfsUnixfsExporter = require('ipfs-unixfs-exporter');

var createNode = require('./utils/create-node.js');

var toPathComponents = require('./utils/to-path-components.js');

var updateMfsRoot = require('./utils/update-mfs-root.js');

var updateTree = require('./utils/update-tree.js');

var addLink = require('./utils/add-link.js');

var withMfsRoot = require('./utils/with-mfs-root.js');

var mergeOpts = require('merge-options');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

var mergeOptions = mergeOpts__default["default"].bind({
  ignoreUndefined: true
});
var log = debug__default["default"]('ipfs:mfs:mkdir');
var defaultOptions = {
  parents: false,
  hashAlg: 'sha2-256',
  cidVersion: 0,
  shardSplitThreshold: 1000,
  flush: true
};

function createMkdir(context) {
  function mfsMkdir(_x) {
    return _mfsMkdir.apply(this, arguments);
  }

  function _mfsMkdir() {
    _mfsMkdir = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path) {
      var options,
          opts,
          pathComponents,
          root,
          parent,
          trail,
          emptyDir,
          i,
          subPathComponents,
          subPath,
          newRootCid,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              opts = mergeOptions(defaultOptions, options);

              if (path) {
                _context.next = 4;
                break;
              }

              throw new Error('no path given to Mkdir');

            case 4:
              path = path.trim();

              if (!(path === '/')) {
                _context.next = 9;
                break;
              }

              if (!opts.parents) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return");

            case 8:
              throw errCode__default["default"](new Error('cannot create directory \'/\': Already exists'), 'ERR_INVALID_PATH');

            case 9:
              if (!(path.substring(0, 1) !== '/')) {
                _context.next = 11;
                break;
              }

              throw errCode__default["default"](new Error('paths must start with a leading slash'), 'ERR_INVALID_PATH');

            case 11:
              log("Creating ".concat(path));
              pathComponents = toPathComponents.toPathComponents(path);

              if (!(pathComponents[0] === 'ipfs')) {
                _context.next = 15;
                break;
              }

              throw errCode__default["default"](new Error('path cannot have the prefix \'ipfs\''), 'ERR_INVALID_PATH');

            case 15:
              _context.next = 17;
              return withMfsRoot.loadMfsRoot(context, opts);

            case 17:
              root = _context.sent;
              trail = [];
              _context.next = 21;
              return createNode.createNode(context, 'directory', opts);

            case 21:
              emptyDir = _context.sent;
              i = 0;

            case 23:
              if (!(i <= pathComponents.length)) {
                _context.next = 52;
                break;
              }

              subPathComponents = pathComponents.slice(0, i);
              subPath = "/ipfs/".concat(root, "/").concat(subPathComponents.join('/'));
              _context.prev = 26;
              _context.next = 29;
              return ipfsUnixfsExporter.exporter(subPath, context.repo.blocks);

            case 29:
              parent = _context.sent;

              if (!(parent.type !== 'file' && parent.type !== 'directory')) {
                _context.next = 32;
                break;
              }

              throw errCode__default["default"](new Error("".concat(path, " was not a UnixFS node")), 'ERR_NOT_UNIXFS');

            case 32:
              if (!(i === pathComponents.length)) {
                _context.next = 36;
                break;
              }

              if (!opts.parents) {
                _context.next = 35;
                break;
              }

              return _context.abrupt("return");

            case 35:
              throw errCode__default["default"](new Error('file already exists'), 'ERR_ALREADY_EXISTS');

            case 36:
              trail.push({
                name: parent.name,
                cid: parent.cid
              });
              _context.next = 49;
              break;

            case 39:
              _context.prev = 39;
              _context.t0 = _context["catch"](26);

              if (!(_context.t0.code === 'ERR_NOT_FOUND')) {
                _context.next = 48;
                break;
              }

              if (!(i < pathComponents.length && !opts.parents)) {
                _context.next = 44;
                break;
              }

              throw errCode__default["default"](new Error("Intermediate directory path ".concat(subPath, " does not exist, use the -p flag to create it")), 'ERR_NOT_FOUND');

            case 44:
              _context.next = 46;
              return addEmptyDir(context, subPathComponents[subPathComponents.length - 1], emptyDir, trail[trail.length - 1], trail, opts);

            case 46:
              _context.next = 49;
              break;

            case 48:
              throw _context.t0;

            case 49:
              i++;
              _context.next = 23;
              break;

            case 52:
              _context.next = 54;
              return updateTree.updateTree(context, trail, opts);

            case 54:
              newRootCid = _context.sent;
              _context.next = 57;
              return updateMfsRoot.updateMfsRoot(context, newRootCid, opts);

            case 57:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[26, 39]]);
    }));
    return _mfsMkdir.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(mfsMkdir);
}

var addEmptyDir = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context, childName, emptyDir, parent, trail, options) {
    var result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            log("Adding empty dir called ".concat(childName, " to ").concat(parent.cid));
            _context2.next = 3;
            return addLink.addLink(context, {
              parent: parent.node,
              parentCid: parent.cid,
              size: 0,
              cid: emptyDir.cid,
              name: childName,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion,
              flush: options.flush,
              shardSplitThreshold: options.shardSplitThreshold
            });

          case 3:
            result = _context2.sent;
            trail[trail.length - 1].cid = result.cid;
            trail.push({
              name: childName,
              cid: emptyDir.cid
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function addEmptyDir(_x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();

exports.createMkdir = createMkdir;